import { useState } from 'react';
import { useQuery } from '/src/api';
import graphQLQueries from './graph-ql-queries';

const useBlocks = () => {
    const {
        data: headerSpecifiedBlock,
        isLoading: isLoadingHeaderSpecifiedBlock,
        runQuery: getHeaderSpecifiedBlock,
    } = useQuery({
        query: graphQLQueries.headerSpecifiedBlock,
        queryKey: ['dynamicBlocks', 'items']
    });
    const {
        data: topMenu,
        isLoading: isLoadingTopMenu,
        runQuery: getTopMenu,
    } = useQuery({
        query: graphQLQueries.topMenu,
        queryKey: ['getTopMenu']
    });

    const {
        data: footerMenu,
        isLoading: isLoadingFooterMenu,
        runQuery: getFooterMenu,
    } = useQuery({
        query: graphQLQueries.footerMenu,
        queryKey: ['getFooter']
    });

    const {
        data: categories,
        isLoading: isLoadingCategories,
        runQuery: getCategories,
    } = useQuery({
        query: graphQLQueries.categories,
        queryKey: ['categories'],
    });
    const [isOpenHeaderSpecifiedBlock, setIsOpenHeaderSpecifiedBlock] = useState(true);

    const getBlocks = () => {
        getHeaderSpecifiedBlock();
        getTopMenu();
        getFooterMenu();
        getCategories();
    };

    return {
        headerSpecifiedBlock: headerSpecifiedBlock ?? [],
        topMenu: topMenu ?? [],
        footerMenu: footerMenu ?? [],
        categories: categories?.items[0].children ?? [],
        isLoadingBlocks: isLoadingHeaderSpecifiedBlock || isLoadingTopMenu || isLoadingFooterMenu || isLoadingCategories,
        getBlocks,
        isOpenHeaderSpecifiedBlock,
        setIsOpenHeaderSpecifiedBlock,
    };
};

export default useBlocks;
